import { AnsweredQuestionWithId } from "@teamprevent/common/model";

export const validateConfidentialitySection = (questions: AnsweredQuestionWithId[]) => {
    const confirmDOB = questions.find(q => q.id === "ConfirmDOB")?.answer === "Confirmed";
    const confirmAddress = questions.find(q => q.id === "ConfirmAddress")?.answer === "Confirmed";
    const confirmOtherIdentifier = questions.find(q => q.id === "ConfirmOtherIdentifier")?.answer === "Confirmed";

    if (confirmDOB && confirmAddress && confirmOtherIdentifier) {
        return { isValid: false, error: "Cannot select all boxes in the Confidentiality section" };
    }

    if (!confirmDOB && !confirmAddress && !confirmOtherIdentifier) {
        return { isValid: false, error: "At least one box must be selected in the Confidentiality section" };
    }

    if ((confirmDOB !== confirmAddress) && !confirmOtherIdentifier) {
        return { isValid: false, error: "If either DOB or address is not confirmed, the last box in the Confidentiality section must be selected" };
    }

    return { isValid: true, error: "" };
};
